// extracted by mini-css-extract-plugin
module.exports = {"daysOfWeekStyle":"_3OAvG4ydcVcb28Izlg1Kn4"};